module.exports = __webpack_public_path__ + "static/img/car_wait.3b8bbf0c.png";